import { useFetchList } from 'store'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import Widget from '@jimmyboys/liita-ui/dist/components/Widget'
import Collection from '@jimmyboys/liita-ui/dist/components/Collection'
import useQueryParams from '@jimmyboys/liita-ui/dist/hooks/useQueryParams'

import queryString from 'query-string'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { ProtocolRowSkeleton } from '../ProcessProtocols/ProtocolRow'

import styles from '../ProtocolsController.module.sass'
import NoData from 'components/general/NoData/NoData'
import LazyLoader from 'components/general/LazyLoader/LazyLoader'
import PresetProtocolRow, { PresetProtocolHeader } from './PresetProtocolRow'
import PresetProtocolsFilters from './PresetProtocolsFilters'
import ActionButton from '@jimmyboys/liita-ui/dist/components/ActionButton'
import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import HStack from '@jimmyboys/liita-ui/dist/components/HStack'

const DEFAULT_PAGE_SIZE = 24

export const presetProtocolsPaginationRequestsUri = (queryParams) => {
	const pageList = new Array(parseInt(queryParams.page, 10) || 1)

	return pageList.fill(null).map((_, index) => {
		const pageQueryParams = {
			...queryParams,
			page: index,
			pageSize: DEFAULT_PAGE_SIZE,
		}
		const qs = queryString.stringify(pageQueryParams)
		const pageUrl = `/rules/protocols_presets?${qs || ''}`

		return pageUrl
	})
}

const PresetProtocolsController = () => {
	const location = useLocation()
	const { i18n, screenSize, showDialog } = useGlobal()

	const [queryParams, , setSearchParams] = useQueryParams(location)

	const pagesRequests = presetProtocolsPaginationRequestsUri(queryParams)

	const {
		contents: [...pages],
	} = useFetchList([...pagesRequests], [], undefined, true)

	const isLoading = pages.some(({ state }) => state === 'loading')

	const lastPageContents = pages[pages.length - 1]?.contents

	const hasMore =
		Array.isArray(lastPageContents) &&
		lastPageContents.length === DEFAULT_PAGE_SIZE

	const items = pages
		.map(({ state, contents }) => {
			const isPageLoading = state === 'loading'
			return isPageLoading
				? new Array(DEFAULT_PAGE_SIZE).fill({
						$cardName: 'ProtocolRowSkeleton',
						$layout: screenSize,
				  })
				: Array.isArray(contents)
				? contents.map((data) => ({
						...data,
						$cardName: 'PresetProtocolRow',
						$layout: screenSize,
				  }))
				: []
		})
		.flat()

	return (
		<>
			<Widget
				paddings={['small', 'normal', '']}
				applyMaxWidth
				className={styles['filters-widget']}
			>
				<HStack justify='space-between'>
					<PresetProtocolsFilters />

					<ActionButton
						className={styles['icon-container']}
						onClick={() => {
							showDialog(
								'EditPresetProtocolDialog',
								i18n`Edit Preset Protocols`,
								{
									bodyPartValue: undefined,
									injuryValue: undefined,
									acutePhaseValue: undefined,
								},
								false,
								undefined,
								'center',
								'edit_preset_protocol'
							).catch(() => null)
						}}
					>
						<Icon name='plus' height='20px' width='20px' />
					</ActionButton>
				</HStack>
			</Widget>
			<Widget
				className={styles['list-header']}
				paddings={['normal', 'normal', '']}
				applyMaxWidth
			>
				<PresetProtocolHeader />
			</Widget>
			<Widget paddings={['small', 'normal', '']} applyMaxWidth>
				{!isLoading && !items.length ? (
					<NoData
						applyMaxWidth
						paddings={['normal', 'normal']}
						message={i18n`Current filters do not match any process.\n\nTry with different filters or reset them.`}
					/>
				) : null}
				<Collection
					items={items}
					itemsHeight={50 + 10}
					renderAhead={20}
					cards={{
						ProtocolRowSkeleton,
						PresetProtocolRow,
					}}
				/>
			</Widget>
			<Widget paddings={['', 'normal', 'normal']} applyMaxWidth>
				<LazyLoader
					isLoading={isLoading}
					hasMore={hasMore}
					onVisible={() => {
						const nextPage = parseInt(queryParams.page, 10) || 1
						setSearchParams({ page: nextPage + 1 })
					}}
				/>
			</Widget>
		</>
	)
}

export default PresetProtocolsController
